import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Shared "came from the launch checklist" flow: pages read ?from=checklist,
// show a back link, and bounce back to the checklist once their task is done.
export function useChecklistReturn() {
  const navigate = useNavigate();
  const fromChecklist = new URLSearchParams(window.location.search).get("from") === "checklist";
  const returnToChecklist = () => {
    if (!fromChecklist) return false;
    navigate("/onboarding/checklist");
    return true;
  };
  return { fromChecklist, returnToChecklist };
}

export const ChecklistBackLink = ({ show }) => {
  const navigate = useNavigate();
  if (!show) return null;
  return (
    <button onClick={() => navigate("/onboarding/checklist")} data-testid="back-to-checklist-link"
      className="text-xs text-slate-400 hover:text-white inline-flex items-center gap-1">
      <ArrowLeft className="w-3 h-3" /> Back to launch checklist
    </button>
  );
};
